/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { PeopleCircle1Icon16Light } from './PeopleCircle1Icon16Light';
import { PeopleCircle1Icon16Regular } from './PeopleCircle1Icon16Regular';
import { PeopleCircle1Icon16Solid } from './PeopleCircle1Icon16Solid';
import { PeopleCircle1Icon20Light } from './PeopleCircle1Icon20Light';
import { PeopleCircle1Icon20Regular } from './PeopleCircle1Icon20Regular';
import { PeopleCircle1Icon20Solid } from './PeopleCircle1Icon20Solid';
import { PeopleCircle1Icon24Regular } from './PeopleCircle1Icon24Regular';
import { PeopleCircle1Icon24Solid } from './PeopleCircle1Icon24Solid';
import { PeopleCircle1Icon32Regular } from './PeopleCircle1Icon32Regular';
import { PeopleCircle1Icon64Regular } from './PeopleCircle1Icon64Regular';
var sizes = {
    16: {
        light: PeopleCircle1Icon16Light,
        regular: PeopleCircle1Icon16Regular,
        solid: PeopleCircle1Icon16Solid,
    },
    20: {
        light: PeopleCircle1Icon20Light,
        regular: PeopleCircle1Icon20Regular,
        solid: PeopleCircle1Icon20Solid,
    },
    24: {
        regular: PeopleCircle1Icon24Regular,
        solid: PeopleCircle1Icon24Solid,
    },
    32: {
        regular: PeopleCircle1Icon32Regular,
    },
    64: {
        regular: PeopleCircle1Icon64Regular,
    },
};
export var PeopleCircle1Icon = forwardRef('PeopleCircle1Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
